module.exports = __webpack_public_path__ + "static/media/BANDHANBNK.811669f6.txt";